var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"text-center"},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-btn',{attrs:{"color":"primary","x-large":"","title":"Stampa distinta"},on:{"click":_vm.stampaDistinta}},[_c('v-icon',{attrs:{"large":""}},[_vm._v(" mdi-printer ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }